import {Theme} from "./theme";

export class ThemeMapper {

  public static map(data: any): Theme {
    let theme: Theme = new Theme();

    theme.id = data.id;
    theme.title = data.title;
    theme.description = data.description;
    theme.fontFamily = data.font_family;
    theme.bgColor = data.colors && data.colors.bg_color || '#ffffff';
    theme.btnColor = data.colors && data.colors.btn_color || '#ffffff';
    theme.iconColor = data.colors && data.colors.icon_color || '#ffffff';
    return theme;
  }

}
